var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('h2',[_vm._v("校友圈详情")])]),_c('br'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }